// extracted by mini-css-extract-plugin
export default {"root":"classes_root__4fPpQ","content":"classes_content__V-k5R","icon":"classes_icon__OCzvD","check-icon":"classes_check-icon__0Ej6J"};